import { LoggingServicePort, LogTransportPort } from '../../ports'

type LogLabelsParam = Record<string, string | number | boolean>

export class LoggingAdapter implements LoggingServicePort {
  constructor(
    private readonly logTransport: LogTransportPort,
    private readonly random: () => number = Math.random
  ) {}

  info(message: string | undefined, labels?: LogLabelsParam): void {
    void this.logTransport.INFO(message, labels)
  }

  error(error: unknown, labels?: LogLabelsParam): void {
    if (error instanceof Error || typeof error === 'string') {
      return this.logTransport.ERROR(error, labels)
    }
    return this.logTransport.ERROR(JSON.stringify(error), labels)
  }
}
